module.exports = __webpack_public_path__ + "img/icon-transaction.dc6fbf46.png";